<template>
  <v-app>
    <app-toolbar></app-toolbar>
    <v-content class="grey lighten-2">
      <div class="px-4 pt-2 pb-2">
          <transition name="router-anim">
              <router-view></router-view>
          </transition>
      </div>
    </v-content>
  </v-app>
</template>

<script>

import AppToolbar from './toolbar'
export default {
  name: 'AppHome',

  components: {
    AppToolbar
  },

  data: () => ({
    //
  }),
  methods: {
    // verificarUsuario () {
    //   var token = this.$cookies.get('token')
    //   if (token == null) {
    //     this.$router.push('/login')
    //   }
    // }
  },
  mounted () {
    // this.verificarUsuario()
  }
}
</script>

<style>
.router-anim-enter-active {
    animation: coming .5s;
    animation-delay: .5s;
    opacity: 0;
}

.router-anim-leave-active {
    animation: going .5s;
}

@keyframes going {
    from {
        transform: translateX(0);
    }

    to {
        transform: translateX(-50px);
        opacity: 0;
    }
}

@keyframes coming {
    from {
        transform: translateX(-50px);
        opacity: 0;
    }

    to {
        transform: translateX(0);
        opacity: 1;
    }
}
</style>
